import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import trashIcon from '@panel/commons/assets/icons/trashIcon.svg';

const StyledTable = styled.table`
  border-collapse: collapse;
  border: 0px;
  border-spacing: 0;
  color: ${select('darkGray')}
  font-family: 'Hind';
  margin: 20px 0 30px 10px;
  width: calc(100% - 30px);
  th {
    background-color: ${select('lightGray')}
    &:last {
      max-width: 30px;
    }
  }
  th, td {
    user-select: text;
    caret-color: transparent;
    padding: 10px 15px;
    text-align: left;
    border: 1px solid ${select('middleGray')};
  }
  tbody > th, td {
    color: ${select('lightBlack')};
  }
  tbody > tr > td:last-child > span {
    display: block;
    width: 100%;
    text-align: center;
    :hover {
      cursor: pointer;
    }
    width: 26px;
    height: 26px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${trashIcon});
    background-size: 24px;
    &.not_allowed {
      opacity: 0.15;
      cursor: not-allowed;
    }
  }
`;

const TableTitle = styled.h3`
  margin: 30px 0 0 10px;
  font-size: 16px;
  font-weight: 500;
`;

function IntegrationsVisualizer({ title = '', headers = [], data = [], onDelete }) {
  const handleRemove = args => {
    if (typeof onDelete === 'function') {
      onDelete(args);
    }
  };
  return (
    <div>
      {title && <TableTitle>{title}</TableTitle>}
      <StyledTable>
        <thead>
          <tr>
            {headers.map(h => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map(it => (
            <tr key={`${it.interfaceId}-${it.integratorId}`}>
              <td>{it.integratorName}</td>
              <td>{it.companyCode}</td>
              <td>
                {it.editable ? (
                  <span title='Desativar' aria-hidden='true' onClick={() => handleRemove(it)} />
                ) : (
                  <span title='Esta integração está ativa e não pode ser desativada' className='not_allowed'>
                    --
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </div>
  );
}

export { IntegrationsVisualizer };
